
import {defineComponent} from "vue";

export default defineComponent({
    name: 'SwitchButton',
    props: {
        id: {
            type: String,
            required: true
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false
        },
        checked: {
            type: Boolean,
            required: false,
            default: false
        },
        onLabel: {
            type: String,
            required: false,
            default: "Oui"
        },
        offLabel: {
            type: String,
            required: false,
            default: "Non"
        },
        isInverse: {
            type: Boolean,
            required: false,
            default: false
        },
        isButton: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    data() {
        return {
            isChecked: false,
        }
    },
    watch: {
        checked: {
            immediate: true,
            handler(newValue: boolean | null, _oldValue: boolean | null) {
                this.isChecked = newValue;
            }
        }
    },
    methods: {
        onChange() {
            this.isChecked = !this.isChecked;
            this.$emit("change", this.isChecked);
        }
    }
});
